<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="sprints"
      :sort-by="[{ key: 'titulomilestone', order: 'asc' }]"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-btn
            style="background: #f9f8f8; font-size: 18px"
            size="small"
            @click="this.$router.go(-1)"
            icon
          >
            <v-icon color="#004984">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >{{
              this.nomeProjetoTitulo
                ? this.nomeProjetoTitulo.replace(/ Sprint \d+$/, '')
                : ''
            }}
            - Sprints
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <ModalCadastrarSprint
            style="margin-right: 40px"
            :idProjeto="parseInt(this.$route.params.id)"
            :nomeProjetoTitulo="this.nomeProjetoTitulo"
            v-if="isCoord || isDev"
          />
        </v-toolbar>

        <!-- Excluir Sprint -->
        <v-dialog v-model="showConfirmationModalExcluir" width="620px">
          <v-card>
            <v-card-title>
              <span>Excluir sprint</span>
            </v-card-title>
            <v-card-text>
              <p>
                Tem certeza que deseja excluir a
                <strong>{{ this.nomeSprint }}</strong
                >?
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="showConfirmationModalExcluir = false"
              >
                Cancelar
              </v-btn>
              <v-btn color="#004984" text @click="excluirSprint">
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Atualizar Sprint -->
        <v-dialog v-model="showConfirmationModalAtualizar" width="620px">
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ nomeSprint }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <p>Início da Sprint</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <p>Fim da Sprint</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <VueDatePicker
                      v-model="dtInicio"
                      auto-apply
                      :min-date="new Date()"
                      :enable-time-picker="false"
                      :format="format(dtInicio)"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <VueDatePicker
                      v-model="dtFim"
                      auto-apply
                      :min-date="dtInicio"
                      :enable-time-picker="false"
                      :format="format(dtFim)"
                    ></VueDatePicker>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="showConfirmationModalAtualizar = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="atualizarSprint"
              >
                Atualizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip text="Backlog de Sprint" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              class="me-2"
              @click="getIdSprintBacklog(item.raw)"
            >
              mdi-view-list
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Contribuição Individual" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              class="me-2"
              @click="getIdSprintContribuicao(item.raw)"
              v-if="isScrum"
            >
              mdi-file
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Atualizar Sprint" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              class="me-2"
              @click="modalAtualizarSprint(item.raw)"
              v-if="isDev || isCoord"
            >
              mdi-calendar-refresh
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Excluir Sprint" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              color="red"
              size="small"
              class="me-2"
              @click="modalExcluirSprint(item.raw)"
              v-if="isDev || isCoord"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Gráfico de Burndown" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              class="me-2"
              @click="getIdSprintBacklogAndProject(item.raw)"
              v-if="isScrum || isDev"
            >
              mdi-chart-areaspline
            </v-icon>
          </template>
        </v-tooltip>
      </template>
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem sprints a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import ModalCadastrarSprint from '@/components/dialogs/ModalCadastrarSprint.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

import '@vuepic/vue-datepicker/dist/main.css';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    ModalCadastrarSprint,
    SnackBar,
    VueDatePicker,
  },
  data: () => ({
    headers: [
      {
        title: 'Título da Sprint',
        align: 'start',
        key: 'titulomilestone',
      },
      { title: 'Data Inicial', key: 'dt_inicio' },
      { title: 'Data Final', key: 'dt_fim' },
      { title: 'Ações', key: 'actions', sortable: false },
    ],
    sprints: [],
    idSprint: null,
    nomeProjetoTitulo: null,
    editedIndex: -1,
    /* eslint-disable */
    editedItem: {
      id_sprint: '',
      numero_sprint: '',
      titulomilestone: '',
      dt_inicio: '',
      dt_fim: '',
      id_repositorio: '',
      id_projeto: '',
    },
    defaultItem: {
      id_sprint: '',
      numero_sprint: '',
      titulomilestone: '',
      dt_inicio: '',
      dt_fim: '',
      id_repositorio: '',
      id_projeto: '',
    },
    /* eslint-enable */
    showConfirmationModalExcluir: false,
    showConfirmationModalAtualizar: false,
    nomeSprint: false,
    dtInicio: new Date(),
    dtFim: new Date(),
  }),

  created() {
    this.fetchSprint();
  },

  methods: {
    format(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    getIdSprintBacklog(item) {
      this.idSprint = item.id_sprint;
      this.$router.push({
        name: 'sprints/backlog',
        params: { id: parseInt(this.idSprint) },
      });
    },
    getIdSprintContribuicao(item) {
      this.idSprint = item.id_sprint;
      this.$router.push({
        name: 'contribution',
        params: { id: parseInt(this.idSprint) },
      });
    },
    getIdSprintBacklogAndProject(item) {
      this.idSprint = item.id_sprint;
      this.idProjeto = item.id_projeto;
      this.$router.push({
        name: 'burndown-chart',
        params: {
          id: parseInt(this.idProjeto),
          idSprint: parseInt(this.idSprint),
        },
      });
    },
    modalExcluirSprint(item) {
      this.idSprint = item.id_sprint;
      this.nomeSprint = item.titulomilestone;
      console.log(item);
      this.showConfirmationModalExcluir = true;
    },
    modalAtualizarSprint(item) {
      this.idSprint = item.id_sprint;
      this.idProjeto = item.id_projeto;
      this.nomeSprint = item.titulomilestone;
      // Conversao de datas DD/MM/YYYY para Date
      const dtInicioParts = item.dt_inicio.split('/');
      const dtFimParts = item.dt_fim.split('/');

      this.dtInicio = new Date(
        parseInt(dtInicioParts[2]),
        parseInt(dtInicioParts[1]) - 1,
        parseInt(dtInicioParts[0]),
      );

      this.dtFim = new Date(
        parseInt(dtFimParts[2]),
        parseInt(dtFimParts[1]) - 1,
        parseInt(dtFimParts[0]),
      );
      console.log(item);
      this.showConfirmationModalAtualizar = true;
    },
    fetchSprint() {
      axios
        .get(API_URL + `/sprints/projeto/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.nomeProjetoTitulo =
              response.data[0].titulomilestone.slice(
                0,
                response.data[0].titulomilestone.length - 1,
              ) +
              (response.data.length + 1);
            /*eslint-disable */
            response.data.forEach((element) => {
              const dt_inicio = new Date(element.dt_inicio);
              const dt_fim = new Date(element.dt_fim);
              this.sprints.push({
                id_sprint: element.id_sprint,
                numero_sprint: element.numero_sprint,
                titulomilestone: element.titulomilestone,
                dt_inicio: `${dt_inicio.getDate()}/${
                  dt_inicio.getMonth() + 1
                }/${dt_inicio.getFullYear()}`,
                dt_fim: `${dt_fim.getDate()}/${
                  dt_fim.getMonth() + 1
                }/${dt_fim.getFullYear()}`,
                id_repositorio: element.id_projeto,
                id_projeto: element.id_projeto,
              });
            });
          }
          /* eslint-enable */
        })
        .catch((error) => {
          console.error(error);
        });
    },
    excluirSprint() {
      axios
        .delete(API_URL + `/sprints/${this.idSprint}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Sprint excluída com sucesso!',
          );
          this.showConfirmationModalExcluir = false;
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          console.error(error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            error.response.data.message,
          );
          this.showConfirmationModalExcluir = false;
        });
    },
    atualizarSprint() {
      /* eslint-disable */
      const data = {
        dtInicio: this.dtInicio.toISOString().replace(/\.\d{3}Z$/, ''),
        dtFim: this.dtFim.toISOString().replace(/\.\d{3}Z$/, ''),
        id_projeto: this.idProjeto,
      };
      console.log(data);
      /* eslint-enable */
      const config = {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .patch(API_URL + `/sprints/${this.idSprint}`, data, config)
        .then(() => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Sprint atualizada com sucesso!',
          );
          this.showConfirmationModalAtualizar = false;
          this.dtInicio = new Date();
          this.dtFim = new Date();
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((error) => {
          this.dtInicio = new Date();
          this.dtFim = new Date();
          console.log(error.response.data.error);
          this.showConfirmationModalAtualizar = false;
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            `${error.response.data.error}`,
          );
        });
    },
  },
  computed: {
    isDev() {
      return localStorage.getItem('funcao') === 'Desenvolvedor';
    },
    isCoord() {
      return localStorage.getItem('funcao') === 'Coordenador';
    },
    isScrum() {
      return localStorage.getItem('funcao') === 'Scrum Master';
    },
  },
};
</script>
<style scoped>
:deep(.dp__outer_menu_wrap) {
  position: fixed;
  z-index: 9999;
  top: 130px;
}
</style>
